import React from "react";
import { useSelector } from "react-redux";
import BottomModal from "../bottomModal/BottomModal";
import { useAppPromotion } from "./useAppPromotion";
import { selectCurrentCluster } from "../../../store/slices/currentClusterSlice";
import { useTheme } from "../../../common/hooks/useTheme";
import styles from "./AppPromotion.module.scss";

// Импорты кнопок магазинов
import appStoreDark from "../../../assets/app-stores/app_store_dark.svg";
import appStoreLight from "../../../assets/app-stores/app_store_light.svg";
import ruStoreDark from "../../../assets/app-stores/ru_store_dark.svg";
import ruStoreLight from "../../../assets/app-stores/ru_store_light.svg";
import { IoLogoAndroid } from "react-icons/io5";
import { ApkButton } from "../apkButton/ApkButton";
import { StoreButton } from "../storeButton/StoreButton";

export const AppPromotion = () => {
  const { modalActive, setModalActive } = useAppPromotion();
  const currentCluster = useSelector(selectCurrentCluster);
  const { isDark } = useTheme();

  const appStoreUrl = process.env.REACT_APP_APPSTORE_URL;
  const ruStoreUrl = process.env.REACT_APP_RUSTORE_URL;
  const directDownloadUrl = process.env.REACT_APP_DIRECT_DOWNLOAD_URL;
  const brandName = currentCluster?.name || "Приложение";

  // Выбор цвета кнопок в зависимости от темы
  const appStoreBadge = isDark ? appStoreLight : appStoreDark;
  const ruStoreBadge = isDark ? ruStoreLight : ruStoreDark;

  // Проверяем, есть ли App Store ссылка
  const hasAppStore = !!appStoreUrl;

  const handleClose = () => setModalActive(false);

  return (
    <BottomModal isVisible={modalActive} onClose={handleClose}>
      <div className={styles.container}>
        {/* Заголовок */}
        <h2 className={styles.title}>
          Установите приложение
          <br />
          <span className={styles.brandName}>{brandName}</span>
        </h2>

        {/* Описание */}
        <p className={styles.description}>
          Быстрый вход, уведомления и лучший опыт использования
        </p>

        {/* Кнопки магазинов */}
        <div className={styles.buttons}>
          {/* App Store - только если есть ссылка */}
          {hasAppStore && (
            <StoreButton
              href={appStoreUrl}
              src={appStoreBadge}
              alt="Скачать в App Store"
            />
          )}

          {/* RuStore */}
          {ruStoreUrl && (
            <StoreButton
              href={ruStoreUrl}
              src={ruStoreBadge}
              alt="Скачать в RuStore"
            />
          )}

          {/* Прямая ссылка для Android с иконкой FaAndroid */}
          {directDownloadUrl && <ApkButton downloadUrl={directDownloadUrl} />}
        </div>

        {/* Fallback для iOS, если нет App Store ссылки - только описание */}
        {!hasAppStore && (
          <div className={styles.iosFallback}>
            <p className={styles.iosMessage}>
              📱 Приложение для App Store скоро появится
            </p>
            <p className={styles.iosHint}>
              Вы можете добавить этот сайт на рабочий стол и использовать как
              приложение
            </p>
          </div>
        )}

        {/* Кнопка "Не сейчас" */}
        <button className={styles.laterButton} onClick={handleClose}>
          Не сейчас
        </button>
      </div>
    </BottomModal>
  );
};
